module.exports = __webpack_public_path__ + "img/Airbnb-Landing-Page-Hybrid-1.228bc4dd.jpg";